<template>
  <div>
    <div class="page-body">
      <div style="display: flex; justify-content: space-between">
        <div style="display: none">
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="right"
            label-width="200px"
            :model="searchForm"
          >
            <el-form-item label="网关名称/编码:">
              <el-input
                placeholder="请输入昵称"
                clearable
                width="200px"
                v-model="searchForm.name"
              ></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search"
              >搜索</el-button
            >
          </el-form>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="showAdd"
            >新增</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table
        :data="dataList"
        stripe
        border
        v-loading="loading"
        element-loading-text="正在加载..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <el-table-column
          prop="gatewayName"
          label="网关名称"
          fixed
          align="center"
          width="300"
        ></el-table-column>
        <el-table-column
          prop="gatewayCode"
          label="网关编号"
          width="300"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="gatewayType"
          label="网关类型"
          width="200"
          align="center"
          :formatter="gatewayTypeFormatter"
        ></el-table-column>
        <el-table-column
          prop="stationName"
          label="所属站点"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="500"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" width="200" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="showEdit(scope.row)">编辑</el-button>
            <el-button @click="confirmDelete(scope.row)" type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px">
      <div style="width: 1200px">
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="150px"
          size="600px"
        >
          <el-form-item label="所属站点:" prop="stationId">
            <el-select
              style="width: 85%"
              filterable
              v-model="form.stationId"
              placeholder="请选择"
              @change="stationIdChange"
            >
              <el-option
                v-for="item in stationIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网关名称:" prop="gatewayName">
            <el-input
              size="mini"
              style="width: 85%"
              prefix-icon="el-icon-edit"
              v-model="form.gatewayName"
              placeholder="请输入网关名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="网关编码:" prop="gatewayCode">
            <el-input
              size="mini"
              style="width: 85%"
              prefix-icon="el-icon-edit"
              v-model="form.gatewayCode"
              placeholder="请输入网关编码"
            ></el-input>
          </el-form-item>

          <el-form-item label="网关类型:">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in gatewayTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :change="gatewayTypeChange"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注:" prop="remark">
            <el-input
              type="textarea"
              style="width: 85%"
              v-model="form.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="footer">
        <el-button type="primary" @click="doUpdate">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import {
  apiList,
  apiUpdate,
  apiGet,
  apiDelete,
  apiListStations,
  apiCount,
} from "./pile-net";

export default {
  name: "gateway-table",
  props: {
    rootStationId: String,
  },
  data() {
    return {
      title: "", //模态窗口 标题
      searchForm: {}, //搜索
      dataList: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      form: {
        gatewayType: 3,
        remoteSiteId: "",
        gatewayName:'',
		size:996
      },
      gatewayTypeOptions: [
        { label: "W1", value: 3 },
        { label: "ZY", value: 5 },
      ],
      stationIdOptions: [],
      stationList: [],
      formRules: {
        gatewayName: [
          { required: true, message: "请输入网关名称", trigger: "blur" },
        ],
        gatewayCode: [
          { required: true, message: "请输入网关编码", trigger: "blur" },
        ],
        remark: [{ required: false, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  created() {
    this.list();
    this.initDictionaryStation();
  },
  mounted() {
    this.$nextTick(function () {
     this.$on("listGateway", function (v1,v2) {
        // console.log("父组件调用2"+JSON.stringify(v1));
        this.listGateway(v1.id);
      });
    });
  },
  methods: {
    list() {
      this.dataList = [];
      console.log("GatewayTable ======" + this.rootStationId);
      let form = this.searchForm;
      form.stationId = this.$props.rootStationId;
      apiList(form).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.dataList = data.list;
          this.total = data.total;
          this.page = data.pageNum;
          this.size = data.pageSize;
        }
      });
    },
    listGateway(id) {
      this.dataList = [];
      this.form.stationId=id;
      let form = this.searchForm;
      form.stationId = id;
      apiList(form).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.dataList = data.list;
          this.total = data.total;
          this.page = data.pageNum;
          this.size = data.pageSize;
        }
      });
    },
    search() {
      this.list();
    },
    showAdd() {
      this.title = "添加网关";
      this.form = { gatewayType: 3, stationId: this.form.stationId,gatewayName:''};
      this.stationIdChange(this.form.stationId);
      this.dialogVisible = true;
    },
    initDictionaryStation() {
      apiListStations({page:1,size:9999}).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
            });
          });
        }
      });
    },
    gatewayTypeChange(row) {
      // console.log(JSON.stringify(row));
    },
    stationIdChange(id) {
      this.stationList.forEach((element) => {
        if (element.id == id) {
          this.form.remoteSiteId = element.remoteSiteId;
        }
      });

      apiCount(id).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.form.gatewayName = parseInt(data.count) + 1 + "";
          let _this = this;
          setTimeout(function(){
              _this.$forceUpdate();
          },300)
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.list();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.list("advanced");
    },
    showEdit(data) {
      this.title = "编辑网关信息";
      this.form = data;
      this.dialogVisible = true;
    },
    confirmDelete(row) {
      this.$confirm(
        "当前计费[" + row.gatewayName + "]将被删除，是否执行此操作",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          console.log("用户选择确认删除");
          this.deleteRow(row);
        })
        .catch(() => {});
    },
    deleteRow(row) {
      console.log("Prepare Delete Record");
      apiDelete(row.id).then((resp) => {
        if (resp.status == 200) {
          Message.success({ message: "删除成功" });
          this.list();
        } else {
          Message.errot({ message: "删除失败:" + resp.data.msg });
        }
      });
    },
    handleChange(v) {
      this.$refs.form.discountRate = v;
    },
    handleChangeFreeFee(v) {
      this.$refs.form.maxFreeMinutes = v;
    },
    handleChangeFreeFee(v) {
      this.$refs.form.maxFreeMinutes = v;
    },
    doUpdate() {
      const valid = this.$refs["formRef"].validate((valid) => {
        if (!valid) {
          return;
        }
        // checkDurationOption();
        apiUpdate(this.form).then((resp) => {
          let type = "更新";
          if (
            this.form.id == undefined ||
            this.form.id == null ||
            this.form.id == 0
          ) {
            type = "添加";
          }
          if (resp.status == 200) {
            Message.success({ message: type + "成功" });
            this.dialogVisible = false;
            this.list();
          }
        });
      });
    },
    gatewayTypeFormatter(row, column, cellValue, index) {
      if (row.type == 3) {
        return "W1";
      }
      if (row.type == 5) {
        return "ZY";
      }
    },
    stationIdFormatter(row, column, cellValue, index) {},
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.el-input--mini .el-input__inner {
  height: 48px;
  line-height: 48px;
}
.footer {
  padding-left: 500px;
}
</style>